import { useState, useEffect, useCallback } from 'react';
import api from '../api';
import Layout from '../components/Layout';

export default function Clienti() {
  const [clienti, setClienti] = useState([]);
  const [cerca, setCerca] = useState('');
  const [mostraForm, setMostraForm] = useState(false);
  const [modifica, setModifica] = useState(null);
  const [mostraCredenziali, setMostraCredenziali] = useState(null);

  const caricaClienti = useCallback(async () => {
    try {
      const res = await api.get('/aziende');
      setClienti(res.data);
    } catch (err) {
      console.error(err);
    }
  }, []);

  useEffect(() => { caricaClienti(); }, [caricaClienti]);

  const filtrati = clienti.filter(c => {
    if (!cerca) return true;
    const q = cerca.toLowerCase();
    return c.ragione_sociale.toLowerCase().includes(q) || c.codice_fiscale.toLowerCase().includes(q);
  });

  const disattiva = async (id) => {
    if (!window.confirm('Disattivare questo cliente?')) return;
    await api.put(`/aziende/${id}/disattiva`);
    caricaClienti();
  };

  return (
    <Layout>
      <div style={styles.topBar}>
        <h2 style={{ margin: 0 }}>Clienti ({filtrati.length})</h2>
        <button onClick={() => { setModifica(null); setMostraForm(true); }} style={styles.btn}>+ Nuovo Cliente</button>
      </div>

      <input
        type="text"
        placeholder="Cerca per ragione sociale o codice fiscale..."
        value={cerca}
        onChange={e => setCerca(e.target.value)}
        style={styles.inputCerca}
      />

      <div style={styles.tableWrapper}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>Ragione Sociale</th>
              <th style={styles.th}>Codice Fiscale / P.IVA</th>
              <th style={styles.th}>Indirizzo</th>
              <th style={styles.th}>Login (Email)</th>
              <th style={styles.th}>Password</th>
              <th style={styles.th}>Azioni</th>
            </tr>
          </thead>
          <tbody>
            {filtrati.map(c => (
              <tr key={c.id} style={styles.tr}>
                <td style={styles.td}>{c.ragione_sociale}</td>
                <td style={styles.td}>{c.codice_fiscale}</td>
                <td style={styles.td}>{c.indirizzo || '—'}</td>
                <td style={styles.td}>{c.utente_email || '—'}</td>
                <td style={styles.td}><PasswordCell password={c.utente_password} /></td>
                <td style={styles.td}>
                  <button onClick={() => { setModifica(c); setMostraForm(true); }} style={styles.btnSmall}>Modifica</button>
                  <button onClick={() => setMostraCredenziali(c)} style={styles.btnSmall}>Credenziali</button>
                  <button onClick={() => disattiva(c.id)} style={styles.btnSmallDanger}>Disattiva</button>
                </td>
              </tr>
            ))}
            {filtrati.length === 0 && (
              <tr><td colSpan={6} style={{ ...styles.td, textAlign: 'center', color: '#999' }}>Nessun cliente trovato</td></tr>
            )}
          </tbody>
        </table>
      </div>

      {mostraForm && (
        <FormCliente
          cliente={modifica}
          onChiudi={() => { setMostraForm(false); setModifica(null); }}
          onSalvato={() => { setMostraForm(false); setModifica(null); caricaClienti(); }}
        />
      )}
      {mostraCredenziali && (
        <FormCredenziali
          cliente={mostraCredenziali}
          onChiudi={() => setMostraCredenziali(null)}
          onSalvato={() => { setMostraCredenziali(null); caricaClienti(); }}
        />
      )}
    </Layout>
  );
}

function PasswordCell({ password }) {
  const [visibile, setVisibile] = useState(false);
  if (!password) return <span style={{ color: '#999' }}>—</span>;
  return (
    <span style={{ display: 'flex', alignItems: 'center', gap: '0.3rem' }}>
      <span style={{ fontFamily: 'monospace', fontSize: '0.85rem' }}>{visibile ? password : '••••••••'}</span>
      <button onClick={() => setVisibile(!visibile)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#888', fontSize: '0.75rem', padding: '2px' }}>
        {visibile ? 'nascondi' : 'mostra'}
      </button>
    </span>
  );
}

function FormCliente({ cliente, onChiudi, onSalvato }) {
  const [form, setForm] = useState(
    cliente
      ? { ragione_sociale: cliente.ragione_sociale, codice_fiscale: cliente.codice_fiscale, indirizzo: cliente.indirizzo || '' }
      : { ragione_sociale: '', codice_fiscale: '', indirizzo: '', email: '', password: '', nome: '', cognome: '' }
  );
  const [errore, setErrore] = useState('');
  const [salvataggio, setSalvataggio] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrore('');
    setSalvataggio(true);
    try {
      if (cliente) {
        await api.put(`/aziende/${cliente.id}`, {
          ragione_sociale: form.ragione_sociale,
          codice_fiscale: form.codice_fiscale,
          indirizzo: form.indirizzo,
        });
      } else {
        await api.post('/auth/registra-cliente', form);
      }
      onSalvato();
    } catch (err) {
      setErrore(err.response?.data?.errore || 'Errore nel salvataggio');
    } finally {
      setSalvataggio(false);
    }
  };

  const aggiorna = (campo, valore) => setForm(prev => ({ ...prev, [campo]: valore }));

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <h3>{cliente ? 'Modifica Cliente' : 'Nuovo Cliente'}</h3>
        <form onSubmit={handleSubmit}>
          {errore && <div style={styles.errore}>{errore}</div>}
          <div style={styles.campo}>
            <label>Ragione Sociale</label>
            <input type="text" value={form.ragione_sociale} onChange={e => aggiorna('ragione_sociale', e.target.value)} required style={styles.input} />
          </div>
          <div style={styles.campo}>
            <label>Codice Fiscale / P.IVA</label>
            <input type="text" value={form.codice_fiscale} onChange={e => aggiorna('codice_fiscale', e.target.value)} required maxLength={16} style={styles.input} />
          </div>
          <div style={styles.campo}>
            <label>Indirizzo</label>
            <input type="text" value={form.indirizzo} onChange={e => aggiorna('indirizzo', e.target.value)} style={styles.input} />
          </div>
          {!cliente && (
            <>
              <hr style={{ border: 'none', borderTop: '1px solid #eee', margin: '1.2rem 0' }} />
              <p style={{ color: '#666', fontSize: '0.85rem', margin: '0 0 1rem' }}>Credenziali di accesso per il cliente</p>
              <div style={styles.row}>
                <div style={styles.campo}>
                  <label>Nome</label>
                  <input type="text" value={form.nome} onChange={e => aggiorna('nome', e.target.value)} required style={styles.input} />
                </div>
                <div style={styles.campo}>
                  <label>Cognome</label>
                  <input type="text" value={form.cognome} onChange={e => aggiorna('cognome', e.target.value)} required style={styles.input} />
                </div>
              </div>
              <div style={styles.campo}>
                <label>Email</label>
                <input type="email" value={form.email} onChange={e => aggiorna('email', e.target.value)} required style={styles.input} />
              </div>
              <div style={styles.campo}>
                <label>Password</label>
                <input type="password" value={form.password} onChange={e => aggiorna('password', e.target.value)} required minLength={6} style={styles.input} />
              </div>
            </>
          )}
          <div style={styles.modalActions}>
            <button type="button" onClick={onChiudi} style={styles.btnSecondary}>Annulla</button>
            <button type="submit" disabled={salvataggio} style={styles.btn}>
              {salvataggio ? 'Salvataggio...' : 'Salva'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

function FormCredenziali({ cliente, onChiudi, onSalvato }) {
  const [form, setForm] = useState({ email: cliente.utente_email || '', password: '' });
  const [errore, setErrore] = useState('');
  const [salvataggio, setSalvataggio] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrore('');
    setSalvataggio(true);
    try {
      await api.put(`/aziende/${cliente.id}/credenziali`, form);
      onSalvato();
    } catch (err) {
      setErrore(err.response?.data?.errore || 'Errore nel salvataggio');
    } finally {
      setSalvataggio(false);
    }
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <h3>Credenziali accesso — {cliente.ragione_sociale}</h3>
        <form onSubmit={handleSubmit}>
          {errore && <div style={styles.errore}>{errore}</div>}
          <div style={styles.campo}>
            <label>Email di accesso</label>
            <input type="email" value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} required style={styles.input} />
          </div>
          <div style={styles.campo}>
            <label>Nuova Password</label>
            <input type="text" value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))} required minLength={6} style={styles.input} placeholder="Minimo 6 caratteri" />
          </div>
          <div style={styles.modalActions}>
            <button type="button" onClick={onChiudi} style={styles.btnSecondary}>Annulla</button>
            <button type="submit" disabled={salvataggio} style={styles.btn}>{salvataggio ? 'Salvataggio...' : 'Salva'}</button>
          </div>
        </form>
      </div>
    </div>
  );
}

const styles = {
  topBar: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem', flexWrap: 'wrap', gap: '1rem' },
  inputCerca: { width: '100%', padding: '0.6rem', border: '1px solid #ddd', borderRadius: '6px', fontSize: '0.95rem', marginBottom: '1rem', boxSizing: 'border-box' },
  tableWrapper: { overflowX: 'auto' },
  table: { width: '100%', borderCollapse: 'collapse', background: 'white', borderRadius: '8px', overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' },
  th: { textAlign: 'left', padding: '0.8rem', background: '#f8f9fa', borderBottom: '2px solid #eee', fontSize: '0.85rem', color: '#555' },
  tr: { borderBottom: '1px solid #f0f0f0' },
  td: { padding: '0.7rem 0.8rem', fontSize: '0.9rem' },
  btn: { background: '#232323', color: 'white', border: 'none', padding: '0.6rem 1.2rem', borderRadius: '6px', cursor: 'pointer', fontSize: '0.9rem' },
  btnSecondary: { background: 'white', color: '#333', border: '1px solid #ddd', padding: '0.6rem 1.2rem', borderRadius: '6px', cursor: 'pointer', fontSize: '0.9rem' },
  btnSmall: { background: '#eef', color: '#232323', border: 'none', padding: '0.3rem 0.7rem', borderRadius: '4px', cursor: 'pointer', marginRight: '0.3rem', fontSize: '0.8rem' },
  btnSmallDanger: { background: '#fee', color: '#c00', border: 'none', padding: '0.3rem 0.7rem', borderRadius: '4px', cursor: 'pointer', fontSize: '0.8rem' },
  overlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 },
  modal: { background: 'white', padding: '2rem', borderRadius: '12px', width: '100%', maxWidth: '500px', maxHeight: '90vh', overflow: 'auto' },
  campo: { marginBottom: '1rem', flex: 1 },
  input: { width: '100%', padding: '0.6rem', border: '1px solid #ddd', borderRadius: '6px', fontSize: '0.95rem', boxSizing: 'border-box', marginTop: '0.3rem' },
  row: { display: 'flex', gap: '1rem' },
  modalActions: { display: 'flex', justifyContent: 'flex-end', gap: '0.5rem', marginTop: '1.5rem' },
  errore: { background: '#fee', color: '#c00', padding: '0.7rem', borderRadius: '6px', marginBottom: '1rem' },
};
